import { z } from 'zod';

export type IRelationshipAsset = z.infer<typeof RelationshipAssetSchema>;

export const RelationshipAssetSchema = z.object({
  idRelationship: z.number().optional(),
  idAsset: z.number(),
  data: z.record(z.any()).optional(),
});

export function createRelationshipAsset(
  idRelationship: number,
  idAsset: number,
  data?: Record<string, any>
): IRelationshipAsset {
  return {
    idRelationship,
    idAsset,
    data,
  };
}
